import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { StackLayout } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';

export const BehavioralHealthPage = () => {
  usePageViewAnalytics({ screen_name: 'Behavioral Health' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_BEHAVIORAL_HEALTH' }));

  return (
    <StackLayout
      orientation="vertical"
      verticalAlignment="center"
      horizontalAlignment="stretch"
      css={{
        marginX: 'auto',
        padding: '$none $two',
        maxWidth: CONTENT_MAX_WIDTH,
        '@mobile': {
          padding: '$none $one',
        },
      }}
    >
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_BEHAVIORAL_HEALTH_PAGE} />
    </StackLayout>
  );
};
